import { useEffect, useState } from 'react';
import type { IsoDate } from '@/domain/content.types';
import { localIsoDate } from '@/domain/schedule';

const CHECK_MS = 60_000;

/**
 * Today's local calendar date, re-read once a minute so a tab left open over
 * midnight rolls a phase from "last day" to "ended" without a reload. State
 * only changes when the date string does, so the poll re-renders nothing.
 */
export function useToday(): IsoDate {
  const [today, setToday] = useState<IsoDate>(() => localIsoDate());
  useEffect(() => {
    const id = setInterval(() => {
      const now = localIsoDate();
      setToday((prev) => (prev === now ? prev : now));
    }, CHECK_MS);
    return () => clearInterval(id);
  }, []);
  return today;
}
